<script type="text/javascript">
import ListComponent from "@/app/shared/components/generic/list/listComponent.vue";

import buttonRenderer from "./renderer/buttonRenderer.vue";

import moment from "moment";
import "moment/locale/fr";

moment.locale("fr");

export default {
  extends: ListComponent,

  props: ["controller", "icon"],

  data() {
    return {
      onRowClicked: "",
      onRowDoubleClicked: "",
      logisticVariantId: null,
      contractor: null
    };
  },

  methods: {
    async onGridReady(params) {
      let gridApi = params.api;
      let self = this;
      let sendResult = null;

      this.dataSource = {
        rowCount: null,
        getRows: async function(params) {
          if (self.contractor) {
            params.filterModel.contractorId = { filter: self.contractor.id, filterType: "number", type: "equals" };

            let query = self.fillListWithFilterAndSort(params);
            self.controller.Log.logDebug(`listLogisticVariantComponent`, `Object query : ${JSON.stringify(query)}`);
            try {
              sendResult = await self.controller.LogisticVariantStore.postFilters(query);

              params.successCallback(sendResult.data.results, sendResult.itemsCount);

              self.hasRows = sendResult.data.results.length > 0;
            } catch (error) {
              //Log
              self.controller.Log.LogError(`listLogisticVariantComponent`, error);
              sendResult = null;
              self.hasRows = false;
            }
          }
        }
      };

      if (self.hasRows) {
        gridApi.setDatasource(this.dataSource);
      }
    },

    onSelectionChanged() {
      let selectedElement = this.gridOptions.api.getSelectedRows()[0];
      this.$parent.selectedlogisticVariant(selectedElement);
    },

    blockClicked(data) {
      let blockingType = "B";
      this.controller.EventBus.$emit("showModal", blockingType, data);
    },

    unblockClicked(data) {
      let blockingType = "D";
      this.controller.EventBus.$emit("showModal", blockingType, data);
    },

    refreshListListener(contractor) {
      if (contractor != null) this.contractor = contractor;
      this.refreshData();
    }
  },

  beforeMount() {
    this.columnDefs = [
      this.numericColumn("id", { headerName: "ID", hide: true, cellRenderer: this.gridOptions.components.loadingRenderer }),
      this.textColumn("sigma", { headerName: "Sigma", headerTooltip: "Code sigma", pinned: "left", width: 100 }),
      this.numericColumn("logisticVariantCode", { headerName: "VL", headerTooltip: "Variante logistique", pinned: "left", width: 80 }),
      this.numericColumn("pcb", { headerName: "PCB", headerTooltip: "Par combien", width: 70 }),
      this.textColumn("name", { headerName: "Désignation", width: 250 }),
      this.numericColumn("palettTotalNumber", {
        headerName: "Pal stk",
        headerTooltip: "Palette en stock",
        width: 80
      }),
      this.numericColumn("parcelTotalNumber", {
        headerName: "Col stk",
        headerTooltip: "Colis en stock",
        width: 80
      }),
      this.numericColumn("csuTotalNumber", {
        headerName: "UVC stk",
        headerTooltip: "UVC en stock",
        width: 80
      }),
      this.numericColumn("netWeightTotal", {
        headerName: "Net stk",
        headerTooltip: "Poids net en stock",
        width: 90
      }),
      this.numericColumn("blockedPalettTotalNumber", {
        headerName: "Pal blo",
        headerTooltip: "Palettes bloquées",
        width: 80
      }),
      this.numericColumn("blockedParcelTotalNumber", {
        headerName: "Col blo",
        headerTooltip: "Colis bloqués",
        width: 80
      }),
      this.numericColumn("blockedCSUTotalNumber", {
        headerName: "UVC blo",
        headerTooltip: "UVC bloquées",
        width: 80
      }),
      this.numericColumn("blockedNetWeightTotal", {
        headerName: "Net blo",
        headerTooltip: "Poids net bloqué",
        width: 90
      }),
      this.chekboxColumn("promo", {
        headerName: "Promo",
        headerTooltip: "VL promotionelle",

        width: 80
      }),
      this.chekboxColumn("toDelete", {
        headerName: "A supprimer",
        headerTooltip: "VL à supprimer",
        width: 80,
        cellClass: "justify-content-center align-items-center aze"
      }),
      this.textColumn("casinoReference", { headerName: "Ref Casino", headerTooltip: "Référence Casino", width: 100 }),
      this.textColumn("fplpReference", { headerName: "Ref FPLP", headerTooltip: "Référence FPLP", width: 100 }),
      this.textColumn("monoprixReference", { headerName: "Ref Monoprix", headerTooltip: "Référence Monoprix", width: 100 }),

      this.textColumn("lock", {
        width: 60,
        headerName: " ",
        pinned: "right",
        resizable: false,
        filter: false,
        sortable: false,
        editable: false,
        suppressSizeToFit: true,
        cellRendererFramework: buttonRenderer,
        cellRendererParams: {
          icon: "mdi-lock", // Complementing the Cell Renderer parameters
          action: this.blockClicked
        },
        cellStyle: { "text-align": "center" }
      }),

      this.textColumn("unlock", {
        width: 60,
        headerName: " ",
        pinned: "right",
        resizable: false,
        filter: false,
        sortable: false,
        editable: false,
        suppressSizeToFit: true,
        cellRendererFramework: buttonRenderer,
        cellRendererParams: {
          icon: "mdi-lock-open", // Complementing the Cell Renderer parameters
          action: this.unblockClicked
        },
        cellStyle: { "text-align": "center" }
      })
    ];

    this.editType = "fullRow";
    this.pinnedTopRowData = null;
    this.addButtonVisibility = false;
    this.deleteButtonVisibility = false;

    this.controller.EventBus.$on("refreshList", this.refreshListListener);
  },

  async beforeDestroy() {
    this.controller.EventBus.$off("refreshList", this.refreshListListener);
  }
};
</script>
